import { IconButton, Text, useAnnaAppContext } from "@anna-money/anna-web-ui";
import { message } from "antd";
import classNames from "classnames";
import copy from "copy-to-clipboard";
import { observer } from "mobx-react-lite";
import type { FC } from "react";
import { LogoIcon } from "../../../../icons/icons";
import type { FormSectionType } from "../obPaymentPageView";
import styles from "./headerViewSection.module.scss";

type PaymentInfoType = {
  beneficiaryName: Nullable<string>;
  beneficiarySortCode: Nullable<string>;
  beneficiaryAccountNumber: Nullable<string>;
};

export const PaymentInfo: FC<PaymentInfoType> = ({
  beneficiaryName,
  beneficiarySortCode,
  beneficiaryAccountNumber,
}: PaymentInfoType) => {
  const handleCopy = (): void => {
    copy(`${beneficiaryName}\nSort code: ${beneficiarySortCode}\nAccount: ${beneficiaryAccountNumber}`);
    message.success("Bank details has been copied to clipboard");
  };
  return (
    <div className={styles.paymentInfo}>
      <LogoIcon />
      <div className={styles.content}>
        <div className={styles.contentText}>
          <span className={styles.subtitle}>{beneficiaryName}</span>
          <span className={styles.text}>Sort code: {beneficiarySortCode}</span>
          <Text className={styles.text} tag="div">
            Account#: {beneficiaryAccountNumber}
          </Text>
        </div>
        <IconButton
          icon="actionDuplicate"
          iconColor="themeGreen"
          title="Copy bank details"
          size="l"
          onClick={handleCopy}
        />
      </div>
    </div>
  );
};

export const HeaderViewSection: FC<FormSectionType> = observer(({ state }) => {
  const isMobile = useAnnaAppContext().displayType === "mobile";
  const {
    backgroundImage,
    logo,
    tradingName,
    beneficiaryName,
    beneficiarySortCode,
    businessType,
    beneficiaryAccountNumber,
  } = state;
  const isFullHeaderView = logo && backgroundImage;
  const isEmptyHeaderView = !logo && !backgroundImage;

  return (
    <>
      <div className={styles.header}>
        {backgroundImage && <img className={styles.backgroundImage} src={backgroundImage} alt="business" />}
        {!!logo && (
          <div className={classNames(styles.logoBlock, !backgroundImage && styles.block)}>
            <>
              <img className={styles.headerLogo} src={logo} alt="logo" />
            </>
          </div>
        )}
      </div>

      <div className={classNames(styles.titleBlock, (isFullHeaderView || isEmptyHeaderView) && styles.withMargin)}>
        <div className={styles.title}>
          <span className={styles.name} role="heading" aria-level={1}>
            {tradingName || beneficiaryName}
          </span>
          <div className={styles.businessType}>{businessType}</div>
        </div>
        {!isMobile && (
          <PaymentInfo
            beneficiaryName={beneficiaryName}
            beneficiarySortCode={beneficiarySortCode}
            beneficiaryAccountNumber={beneficiaryAccountNumber}
          />
        )}
      </div>
    </>
  );
});
